import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    adresse: '',
    telephone: '',
    description: '',
    statut: 'actif',
    user_id: user?.id,
    pays: '',
    ville: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const resetForm = () => {
    setFormData({
      nom: '',
      adresse: '',
      telephone: '',
      description: '',
      statut: 'actif',
      user_id: user?.id,
      pays: '',
      ville: '',
    });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${APP_API_URL}/fournisseurs`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: 'Le fournisseur a été ajouté avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'enregistrement.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter un fournisseur"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-supplier-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-supplier-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-supplier-nom" className="duo-form-label">
            Nom *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-supplier-nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-supplier-adresse" className="duo-form-label">
                Adresse
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-supplier-adresse"
                name="adresse"
                value={formData.adresse}
                onChange={handleChange}
              />
              {errors.adresse && <p className="text-danger small mt-1 mb-0">{errors.adresse[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-supplier-telephone" className="duo-form-label">
                Téléphone
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-supplier-telephone"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
              />
              {errors.telephone && <p className="text-danger small mt-1 mb-0">{errors.telephone[0]}</p>}
            </div>
          </div>
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-supplier-description" className="duo-form-label">
            Description
          </label>
          <textarea
            className="duo-input"
            id="add-supplier-description"
            name="description"
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
          {errors.description && <p className="text-danger small mt-1 mb-0">{errors.description[0]}</p>}
        </div>
        <div className="row g-2">
          <div className="col-md-6">
            <div className="duo-form-group">
              <label htmlFor="add-supplier-pays" className="duo-form-label">
                Pays
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-supplier-pays"
                name="pays"
                value={formData.pays}
                onChange={handleChange}
              />
              {errors.pays && <p className="text-danger small mt-1 mb-0">{errors.pays[0]}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="duo-form-group mb-0">
              <label htmlFor="add-supplier-ville" className="duo-form-label">
                Ville
              </label>
              <input
                type="text"
                className="duo-input"
                id="add-supplier-ville"
                name="ville"
                value={formData.ville}
                onChange={handleChange}
              />
              {errors.ville && <p className="text-danger small mt-1 mb-0">{errors.ville[0]}</p>}
            </div>
          </div>
        </div>
      </form>
    </DuoModal>
  );
}
